import {isValid} from 'validators/number-validator';

export const isActive = (activeIndex, index, interactive = true) => {
  if (
    isValid(activeIndex) &&
    isValid(index) &&
    activeIndex === index &&
    interactive
  ) {
    return true;
  }
  return false;
};
